module.exports = "/fonts/vendor/mavon-editor/dist/fontello.woff?197592f265b107ac72ee143dfe75e027";